var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-market-item-orders-cards"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"page-market-item-orders-cards__item"},[_c('page-market-item-orders-cards-item',{attrs:{"item":item,"is-user-shareless":_vm.isUserShareless}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }